import './HeaderGenericSecondary.css';
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { commonStyles, ltrStyles, rtlStyles } from '../57_HeaderGenericPrimary/HeaderGenericPrimary';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
const HeaderGenericSecondary = _ref => {
  let {
    rendering,
    fields,
    children,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const darkMode = get(sitecoreContext, 'darkMode');
  const actions = get(sitecoreContext, 'actions', {});
  const dictionary = get(fields, 'data.dictionary');
  const darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  const {
    changeThemeFunction = () => {}
  } = actions;
  if (!fields) {
    console.warn('HeaderGenericSecondary component render skipped. No params provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }
  const hasTitle = Boolean(get(fields, 'pageTitle.value'));
  const hasText = Boolean(get(fields, 'pageIntro.value'));
  let pageName = get(fields, 'headerTag');
  const dotSite = get(sitecoreContext, 'site.name');
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'pageName');
  }
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-secondary",
      rendering: rendering,
      mediaDesc: fields.pageIntro.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isSharedCh: isSharedCh
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }))), /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-block"
  }, pageName && pageName.value && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: pageName,
    className: "c-category__text"
  }), hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: fields.pageTitle,
    className: "c-title__text"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header__media"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, hasText ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p header__content",
    field: fields.pageIntro
  }) : /*#__PURE__*/React.createElement("p", {
    className: "p header__content",
    style: {
      minHeight: '16px'
    }
  }))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  const commonStyleVar = !isSharedCh ? commonStylesSpecific : "c1q9vhy7";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${commonStyles} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${rtl ? componentRtlStyles : componentLtrStyles}
     ${commonStyleVar} ${headerImageStyle} ${thisHeaderStyles}`
  }, children);
};
const commonStylesSpecific = "ckqzppl";
const componentLtrStyles = "c18bpany";
const componentRtlStyles = "c9to2ba";
const thisHeaderStyles = "t5fpvy7";
export default HeaderGenericSecondary;